import SelectCount from './SelectCount.vue';

export default SelectCount;



// WEBPACK FOOTER //
// ./src/pages/profile/components/selectcount/index.ts